
<div class="col-xs-12 px-3 chat-box" *ngIf="webAppUrl" #chatBox style="height:{{height}};overflow-y:auto;">
  <iframe class="hbox" #newChatView [src]="webAppUrl"></iframe>
</div>
